import { ServiceType, ServiceConfig } from '../types'

export const serviceConfigs: Record<ServiceType, ServiceConfig> = {
  [ServiceType.HR]: {
    id: ServiceType.HR,
    name: 'HR Templates',
    description: 'Professional recruitment templates and branded hiring pages that convert candidates into applications. Build your custom hiring page in minutes with our proven templates.',
    shortDescription: 'Get Your Branded Hiring Page – From €1,000',
    baseUrl: '/hr',
    pricing: 'From €1,000',
    ctaText: 'Start Building',
    icon: 'users',
    features: [
      'Custom branded application forms',
      'Multi-step application process',
      'Mobile-responsive design',
      'Admin dashboard & analytics',
      'Instant deployment'
    ],
    isActive: true,
    status: 'active',
    accentColor: '#10b981' // Green for growth/hiring
  },
  [ServiceType.COMPLIANCE]: {
    id: ServiceType.COMPLIANCE,
    name: 'Compliance & Insurance',
    description: 'Protect Your Business from EU Recalls with comprehensive compliance monitoring, product recall insurance, and legal documentation. Stay ahead of regulatory changes with 24/7 monitoring.',
    shortDescription: 'Protect Your Business from EU Recalls',
    baseUrl: '/compliance',
    pricing: 'From €500/month',
    ctaText: 'Coming Soon',
    icon: 'shield-check',
    features: [
      'EU compliance monitoring',
      'Product recall insurance',
      'Legal documentation',
      'Risk assessment reports',
      '24/7 compliance alerts'
    ],
    isActive: false,
    accentColor: '#f59e0b', // Amber for caution/protection
    status: 'inactive'
  },
  [ServiceType.RARE_EARTH_PERMIT]: {
    id: ServiceType.RARE_EARTH_PERMIT,
    name: 'Rare Earth Permits',
    description: 'Secure verified rare-earth export permits and navigate complex international trade regulations. Get expert guidance for mineral export compliance and documentation with guaranteed approval.',
    shortDescription: 'Secure Verified Rare-Earth Export Permits',
    baseUrl: '/rare-earth-permit',
    pricing: 'From €3,500',
    ctaText: 'Get Permits',
    icon: 'gem',
    features: [
      'Rare-earth export permits',
      'International compliance',
      'Expert documentation',
      'Regulatory guidance',
      'Guaranteed approval'
    ],
    isActive: true,
    accentColor: '#7c3aed', // Purple for premium/minerals
    status: 'active'
  },
  [ServiceType.TRADE]: {
    id: ServiceType.TRADE,
    name: '5G Recommerce',
    description: 'Transform your business with AI-powered 5G technology solutions and hardware recommerce platform. Connect with verified suppliers and access cutting-edge telecommunications equipment.',
    shortDescription: 'AI-Powered 5G Technology Solutions',
    baseUrl: '/trade',
    pricing: 'From €2,500',
    ctaText: 'Explore 5G',
    icon: 'radio',
    features: [
      '5G hardware sourcing',
      'AI-powered matching',
      'Verified supplier network',
      'Technical consultation',
      'Installation support'
    ],
    isActive: true,
    accentColor: '#8b5cf6', // Purple for technology
    status: 'active'
  },
  [ServiceType.INTELLIGENCE]: {
    id: ServiceType.INTELLIGENCE,
    name: 'Business Intelligence',
    description: 'Discover Hiring Companies Instantly with AI-powered job market analysis and lead generation. Get real-time insights into company hiring patterns and market trends to stay ahead of the competition.',
    shortDescription: 'Discover Hiring Companies Instantly',
    baseUrl: '/intelligence',
    pricing: 'From €200/month',
    ctaText: 'Start Discovery',
    icon: 'brain',
    features: [
      'AI-powered job scraping',
      'Company hiring insights',
      'Lead generation tools',
      'Market trend analysis',
      'Real-time notifications'
    ],
    isActive: true,
    accentColor: '#06b6d4', // Cyan for technology/data
    status: 'active'
  },
  [ServiceType.VERPACKG]: {
    id: ServiceType.VERPACKG,
    name: 'VerpackG-Löschung',
    description: 'Professional LUCID registry de-registration service for foreign Amazon sellers. Eliminate ongoing compliance liability with our automated German bureaucracy handling using authorized representation.',
    shortDescription: 'Eliminate German Packaging Compliance Liability',
    baseUrl: '/verpackg-loschung',
    pricing: '€390 one-time',
    ctaText: 'Start De-registration',
    icon: 'document-remove',
    features: [
      'Complete LUCID de-registration',
      'Authorized German representation',
      'Document validation & processing',
      'Legal compliance guarantee',
      'Money-back guarantee'
    ],
    isActive: true,
    accentColor: '#dc2626', // Red for removal/elimination
    status: 'active'
  }
}

export const getServiceConfig = (serviceType: ServiceType): ServiceConfig => {
  return serviceConfigs[serviceType]
}

export const getAllServices = (): ServiceConfig[] => {
  return Object.values(serviceConfigs)
}

export const getActiveServices = (): ServiceConfig[] => {
  return Object.values(serviceConfigs).filter(service => service.isActive)
}